<div class="material-page">
  <div class="mdc-layout-grid">
    <div class="mdc-layout-grid__inner">
    
      <div class="left mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
        <h1 class="mat-headline-2" i18n>Success! What's next?</h1>
        
        <h1 i18n>Share the listing on your social media</h1>
        <p i18n>Your listing is now visible on our marketplace, and potential buyers can message you directly. We'll notify you through your Listx inbox and send you an email whenever someone reaches out.</p>
        <p i18n>While you wait, feel free to spread the word about your listing on your social media accounts. This simple step improves your chances of finding a buyer.</p>
        
        <h1 i18n>Complete the sale</h1>
        <p i18n>Once you've connected with an interested buyer through our chat and worked out the pricing and shipping details, you're almost done.</p>
        <p i18n>For added security and to reduce the risk of fraud, we suggest either meeting in person or opting for a payment-on-delivery option, to complete the sale.</p>
        
        <h1 i18n>Update the listing</h1>
        <p i18n>You can edit your listing or remove it entirely by simply clicking on the item on the "My Items" page.</p>
        
        <div class="button-panel">
            
          <button 
              mat-raised-button 
              color="accent"
              (click)="toSelectListingFlow()"
              angulartics2On="click" angularticsAction="ListSomethingElse" i18n>LIST SOMETHING ELSE</button>
            
          <button 
              mat-stroked-button 
              (click)="toItemList()"
              angulartics2On="click" angularticsAction="BackToMyItems" i18n>BACK TO MY ITEMS</button>
        </div>
      </div>
      
    </div>
  </div>
</div>